import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '60%',
  },
  containerMobile: {
    width: '100%',
  },
  waiting: {
    background: theme.palette.common.white,
    padding: 24,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  waitingMobile: {
    background: theme.palette.common.white,
    padding: 24,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
  },
  textWaiting: {
    padding: '24px 16px 0 16px',
    color: theme.palette.primary.dark,
  },
  darkBlue: {
    color: theme.palette.primary.dark,
    paddingRight: 16,
  },
  textDarkBlue: {
    color: theme.palette.primary.dark,
    padding: '0 16px',
  },
  span: {
    marginLeft: '1ch',
  },
  list: {
    textTransform: 'lowercase',
  },
}))
